import { isFreeItem } from 'components/Sell/DiscountBogoDialog/hook/buyXgetYProcess'
import Decimal from 'decimal.js'
import { IServiceCharge } from 'store/models/sellModels'
import { round } from './common'
import { LineModelExtend } from './models/IOrderCalculationModel'

export function getServiceChargeRate(
    orderServiceChageRate: number | undefined,
    isIncludeComp: boolean,
    isOrderComp: boolean,
) {
    const serviceChargeRate = new Decimal(0)

    if (
        !orderServiceChageRate ||
        orderServiceChageRate === 0 ||
        (isOrderComp && !Boolean(isIncludeComp))
    )
        return serviceChargeRate

    return new Decimal(orderServiceChageRate)
}

export const calculateOrderServiceCharge = (
    serviceCharge: IServiceCharge,
    lines: LineModelExtend[],
    isOrderComp: boolean,
) => {
    const { setting, orderServiceChageRate } = serviceCharge

    const serviceChargeRate = getServiceChargeRate(
        orderServiceChageRate,
        setting?.isIncludeComp ?? false,
        isOrderComp,
    ).div(100)

    return lines
        .filter((l) => !l.isDepositAndCreditItem)
        .reduce((prev, cur) => {
            const lineTotal =
                (cur.isComp && !setting?.isIncludeComp) || isFreeItem(cur)
                    ? new Decimal(0)
                    : setting?.isCalculateAfterDiscount
                      ? getLineNetSubtotal(cur)
                      : cur.subtotal!
            return prev.plus(lineTotal.mul(serviceChargeRate))

            function getLineNetSubtotal(cur: LineModelExtend) {
                const subItemOrderDiscount = cur.comboItems.reduce(
                    (prev, cur) => {
                        return prev.plus(cur.orderDiscountAmount ?? 0)
                    },
                    new Decimal(0),
                )
                return cur
                    .subtotal!.sub(cur.itemDiscountAmount ?? 0)
                    .sub(cur.lineCompDiscount ?? 0)
                    .sub(cur.orderDiscountAmount)
                    .sub(subItemOrderDiscount)
            }
        }, new Decimal(0))
}

export const calculateLineServiceCharge = (
    serviceCharge: IServiceCharge,
    line: LineModelExtend,
    isOrderComp: boolean,
) => {
    if (line.isDepositAndCreditItem) return new Decimal(0)

    const { setting, orderServiceChageRate } = serviceCharge

    const serviceChargeRate = getServiceChargeRate(
        orderServiceChageRate,
        setting?.isIncludeComp ?? false,
        isOrderComp,
    ).div(100)

    if ((setting?.isIncludeComp && line.isComp) || isFreeItem(line)) {
        return new Decimal(0)
    }
    const lineTotal = setting?.isCalculateAfterDiscount
        ? line
              .subtotal!.sub(line.itemDiscountAmount ?? 0)
              .sub(line.lineCompDiscount ?? 0)
              .sub(line.orderDiscountAmount)
        : line.subtotal

    return round(lineTotal!.mul(serviceChargeRate))
}
